import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-objective-type-tooltip-modal',
  templateUrl: './objective-type-tooltip-modal.component.html',
  styleUrls: ['./objective-type-tooltip-modal.component.scss'],
})
export class ObjectiveTypeTooltipModalComponent {

  constructor(private modalController: ModalController) { }

  close() {
    this.modalController.dismiss();
  }

}
